import React, { useEffect } from 'react';
import MarkingCorrectionHistoryReportDataTable from './MarkingCorrectionHistoryReportDataTable';

const MarkingCorrectionHistoryReportIndex = ({ rrhh }) => {
  useEffect(() => window.scrollTo(0, 0), []);
  return <MarkingCorrectionHistoryReportDataTable rrhh={rrhh} />;
};

export default MarkingCorrectionHistoryReportIndex;
